import * as Html from "../../util/Html.ts";
import * as CustomInput from "../../util/CustomInput.ts";
import { OS } from "../../lib/os.ts";
import * as FwDatas from "../../FwDatas.ts";
import { getTimezonesSelect, rememberUsedTimezone } from "../../lib/TimezoneUtils.ts";
import {initDom as placePickerInitDom} from "./place-picker.ts"

Html.registerWidget('widget/form/eventedit',{initDom:initDom as (a:HTMLElement)=>void})

//this stupid firefox doesn't understand change of type without removing the node and reputting it.'
function refresher(hop : HTMLElement){
  var parent = hop.parentNode;
  parent.removeChild(hop);
  parent.appendChild(hop);
}

type EditEventFormElement = HTMLFormElement&{
  scope:HTMLInputElement,
  private:HTMLInputElement,
  allDay:HTMLInputElement,
  startDate:HTMLInputElement,
  endDate:HTMLInputElement,
  timeZone:HTMLSelectElement,
  where:HTMLInputElement,
  isToAll:HTMLInputElement
}

function initDom(dom : HTMLFormElement){
  var
    form = dom as EditEventFormElement,
    isUpdate = Html.getDomMetaId(form),
    isOtherScope = form.scope && form.scope.value!=FwDatas.getFamily().metaId;

  if(isOtherScope){
    form.setAttribute("data-fw-dyn-action","custom.evtcreateotherscope");
  }else if(isUpdate){
    form.setAttribute("data-fw-dyn-action","custom.evtupdate");
    form.setAttribute("data-fw-form-amplify","eventUpdated");
  }else{
    form.setAttribute("data-fw-dyn-action","custom.evtcreate");
    form.setAttribute("data-fw-form-amplify","eventCreated");
  }


  form.private?.addEventListener('change',function(){
    const isToAll = form.isToAll.value==='true'
    if(isToAll && this.value==='true'){
      form.querySelector("[data-accountid='"+FwDatas.getUser().accountId+"']")?.dispatchEvent(new Event('click', {bubbles: true}))
    }
  })

  const
    startDateInput = form.startDate,
    endDateInput = form.endDate,
    morebutton =  form.querySelector<HTMLElement>('.morebutton'),
    timeZoneSelect = form.timeZone,
    timeZoneLabel = timeZoneSelect.parentNode as HTMLElement,
    defaultTimeZone = OS.getTimeZone();

  let
    timezone = timeZoneSelect.getAttribute("data-value")||OS.getTimeZone(),
    //those fields are just to check changes, value to take in account are the ones of the input
    isMore = false,
    start = CustomInput.getDateValue(startDateInput),
    end = CustomInput.getDateValue(endDateInput),
    allDay = form.allDay.checked;

  //delegated because it might be long for slow computer
  setTimeout(function(){
    timeZoneSelect.innerHTML = getTimezonesSelect()
    timeZoneSelect.querySelector(`option[value="${timezone||defaultTimeZone}"]`)?.setAttribute('selected','selected');
  },0)
  function setDate(){
    CustomInput.setDateValue(startDateInput,null);
    CustomInput.setDateValue(endDateInput,null);
    if(allDay){
      timeZoneSelect.setAttribute('disabled','disabled')
      timeZoneLabel.style.display = 'none'
      startDateInput.setAttribute('type','date')
      endDateInput.setAttribute('type','date')
    }else{
      timeZoneSelect.removeAttribute("disabled");
      if(isMore || (timezone && timezone!==defaultTimeZone)){
        timeZoneLabel.style.display = ''
      }else{
        timeZoneLabel.style.display = 'none'
      }
      startDateInput.setAttribute('type','datetime-local')
      endDateInput.setAttribute('type','datetime-local')
    }

    startDateInput.setAttribute('timezone',timezone)
    CustomInput.setDateValue(startDateInput, start)
    endDateInput.setAttribute('timezone',timezone)
    CustomInput.setDateValue(endDateInput, end)

    refresher(startDateInput)
    refresher(endDateInput)
  }
  setDate()
  function alldayMaj(){
    if(allDay === form.allDay.checked) return;
    allDay = form.allDay.checked;
    setDate()
  }
  form.allDay.addEventListener('change',alldayMaj);

  startDateInput.addEventListener('change',function(event){
    const
      newDate = CustomInput.getDateValue(startDateInput),
      duration = end.getTime()-start.getTime();
    if(!newDate) {
       CustomInput.setDateValue(startDateInput,start)
       return;
    }
    if(allDay){
      start.setFullYear(newDate.getFullYear())
      start.setDate(newDate.getDate())
      start.setMonth(newDate.getMonth())
    }else{
      start = newDate;
    }
    end = new Date(start.getTime()+duration)
    CustomInput.setDateValue(endDateInput,end)

  })
  //WARNING it is onblur and not onchange because when you type "12" onchange is triggered first with "1" and after with "12" so with "1" it put the start at 0
  endDateInput.addEventListener('blur',function(event){

    var
      newDate = CustomInput.getDateValue(endDateInput);
    if(!newDate) {
       CustomInput.setDateValue(endDateInput,end)
       return;
    }

    if(allDay){
      end.setFullYear(newDate.getFullYear())
      end.setDate(newDate.getDate())
      end.setMonth(newDate.getMonth())
    }else{
      end = newDate;
    }
    if(start>end){
      start = new Date(end.getTime()-3600000)

      CustomInput.setDateValue(startDateInput,start)
    }
  })
  timeZoneSelect.addEventListener('change',function(){
    timezone = this.value
    startDateInput.setAttribute("timezone",timezone)
    endDateInput.setAttribute("timezone",timezone)
    rememberUsedTimezone(timezone)
  })

  morebutton.addEventListener('click',function(){
    (morebutton.previousElementSibling as HTMLElement).style.display='block';
    morebutton.remove();
    const whereInput = form.where;
    if(whereInput) {
      placePickerInitDom(whereInput);
    }
    isMore = true;
    setDate()
  })

}